import { render } from "./CourseCategories.vue?vue&type=template&id=21a50714&scoped=true"
import script from "./CourseCategories.vue?vue&type=script&lang=js"
export * from "./CourseCategories.vue?vue&type=script&lang=js"

import "./CourseCategories.vue?vue&type=style&index=0&id=21a50714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a50714"]])

export default __exports__